module.exports = __webpack_public_path__ + "static/media/car-4.8f5a3280.png";